import { Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";
import { Container, GlobalStyles } from "assets/jss/common-styles";

const styles = (theme: Theme) => createStyles({
    "@global": {
        ...GlobalStyles(theme),
    },

    container: {
        ...Container,
        zIndex: 2,
        position: "relative",
        height: "100vh"
    },

    logo: {
        textAlign: "center"
    },

    page: {
        backgroundColor: theme.palette.primary.dark,
        backgroundImage: "url(/api/v1.0/Session/Background)",
        backgroundSize: "cover",
        backgroundPosition: "top center"
    },

    pageHeader: {
        minHeight: "100vh",
        maxHeight: "1200px",
        height: "auto",
        display: "inherit",
        position: "relative",
        margin: "0",
        padding: "0",
        border: "0",
        alignItems: "center",
        "&:before": {
            background: "rgba(0, 0, 0, 0.5)"
        },
        "&:before,&:after": {
            position: "absolute",
            zIndex: 1,
            width: "100%",
            height: "100%",
            display: "block",
            left: "0",
            top: "0",
            content: '""'
        },
        "& footer li a,& footer li a:hover,& footer li a:active": {
            color: "#FFFFFF"
        }
    },

    cardFooter: {
        paddingTop: "0rem",
        border: "0",
        borderRadius: "6px",
        justifyContent: "center !important"
    },

    optionsBlock: {
        color: theme.palette.common.white,
        marginTop: "10px",
        "& a": {
            color: theme.palette.grey[200],
            textDecoration: "none"
        },
        "& a:hover": {
            color: theme.palette.common.white,
        },
    },
});

export default styles;
